import React, { Component } from "react";
import { observer } from "mobx-react";
import "./index.css";
import xinaixin from "../../static/images/xinaixin.png";
import xinaixins from "../../static/images/xinaixin-s.png";
@observer
class TagQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showId: props.rowID,
      scrTop: this.props.scrTop,
    };
  }
  changeShowId(rowData) {
    this.props.changeShowId(rowData);
  }
  render() {
    return (
      <div
        key={this.props.rowID}
        className="article"
        onClick={() => {
          this.changeShowId(this.props.rowData);
        }}
      >
        <div className="article-title">
          <p>
            {this.props.rowData &&
            this.props.rowData.storeQuestionEntity &&
            this.props.rowData.storeQuestionEntity.title
              ? this.props.rowData.storeQuestionEntity.title
              : this.props.rowData &&
                this.props.rowData.storeQuestionEntity &&
                this.props.rowData.storeQuestionEntity.question}
          </p>
          <div className="zan_box">
            {this.props.rowData.storeQuestionEntity.likeCount > 0 ? (
              <img className="zan" src={xinaixin} alt="" />
            ) : (
              <img className="zan" src={xinaixins} alt="" />
            )}
            <span className="zan_n">
              {this.props.rowData.storeQuestionEntity.likeCount}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
export default TagQuestion;
